import { render, staticRenderFns } from "./MasivOT.vue?vue&type=template&id=2096709f&"
import script from "./MasivOT.vue?vue&type=script&lang=js&"
export * from "./MasivOT.vue?vue&type=script&lang=js&"
import style0 from "./MasivOT.vue?vue&type=style&index=0&id=2096709f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports